import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import TextExpander from "../../../components/TextExpander";

const VariantColumn = ({
  variantSummary,
  isGene,
  variant,
  variantOrigin,
  variantCivicUrl,
}) => {
  return (
    <>
      <div>
        {variant && (
          <a target="_blank" href={getVarsoUrl(variantCivicUrl)}>
            {variant}
          </a>
        )}
        {variantOrigin && (
          <span>
            <br />
            <small>{`(${variantOrigin})`}</small>
          </span>
        )}
      </div>
      {isGene && variantSummary && (
        <div>
          <span className="tw-mb-1">
            <strong>Variant summary</strong>
          </span>
          <div className="">
            <TextExpander text={variantSummary} truncate={150} />
          </div>
        </div>
      )}
    </>
  );
};

VariantColumn.propTypes = {
  variant: PropTypes.string,
  variantOrigin: PropTypes.string,
  variantSummary: PropTypes.string,
  variantCivicUrl: PropTypes.string,
  isGene: PropTypes.bool,
};

VariantColumn.defaultProps = {
  variant: "",
  variantOrigin: "",
  variantSummary: "",
  variantCivicUrl: "",
  isGene: false,
};

export default VariantColumn;
